import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { LineChart } from './admin/components/line-chart';

// yearly_active_days arrives keyed by year, e.g. { '2023': 120, '2024': 98 }, with
// any year the member did not train zero-filled by the API. Sorted explicitly:
// object key order happens to be numeric for keys like these, but relying on that
// would be a quiet way to get the years out of order.
const toSeries = (yearlyActiveDays) =>
  Object.keys(yearlyActiveDays)
    .map((year) => ({ year: Number(year), activeDays: yearlyActiveDays[year] }))
    .filter((entry) => !Number.isNaN(entry.year))
    .sort((a, b) => a.year - b.year)
    .map((entry) => ({ x: String(entry.year), y: entry.activeDays || 0 }));

const ActiveDaysTimeline = ({ yearlyActiveDays = {} }) => {
  const data = toSeries(yearlyActiveDays);

  if (!data.length) return null;

  const totalActiveDays = data.reduce((total, point) => total + point.y, 0);
  const yearLabel = data.length === 1 ? 'year' : 'years';

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">Active days over time</Typography>
        <Typography variant="body2" color="textSecondary">
          {totalActiveDays} total active days across {data.length} {yearLabel}
        </Typography>
        <LineChart
          sectionKey="yearly-active-days"
          firstDataSet={data}
          maxCheckins={1}
        />
      </CardContent>
    </Card>
  );
};

export default ActiveDaysTimeline;
